import { gql } from '@apollo/client';

export const SYNCHRONIZE_CUSTOMER_FILE = gql`
	mutation SynchronizeCustomerFile($customerFileId: ID!, $fiscalYearId: ID) {
		synchronizeCustomerFile(customerFileId: $customerFileId, fiscalYearId: $fiscalYearId)
	}
`;
